import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch, MdAdd } from "react-icons/md";
import Button from "react-bootstrap/Button";
import editpic from "../../assets/edit.svg";
import deletepic from "../../assets/delete.svg";
import forwardpic from "../../assets/forward.svg";
import view from "../../assets/view.svg";
import { Image, Popover } from "react-bootstrap";
import greenradio from "../../assets/green-radio.svg";
import redradio from "../../assets/red-radio.svg";
import { useState } from "react";
import { ManageCouponsApi } from "../../Utils/Api/ManageCoupons";
import { format } from "date-fns";
import { useEffect } from "react";
import { DeleteCouponApi } from "../../Utils/Api/DeleteCouponApi";
import { RemoveSortkeys, userId } from "../../Utils/LocalStorage";
import sortpic from "../../assets/sort.svg";
import MyVerticallyCenteredModal from "../../Components/DeleteModal/DeleteModal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";
import Pagination from "../../Components/Pagination/Pagination";
import Loader from "../../Components/Loader/Loader";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import { toast } from "react-toastify";
import DuplicateIcon from "../../assets/CreateDuplicateIcon.svg";
import { LatestCouponsApi } from "./../../Utils/Api/LatestCouponsList";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";

const ManageCouponsCouponDashboard = (props) => {
  const [manageCouponsData, setManageCoupons] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [deleteId, setDeleteID] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [flag, setFlag] = useState({
    coupon_name: 0,
    mms_city_name: 0,
    coupon_code: 0,
    download_count: 0,
    redeemed_count: 0,
  });

  const shareUrl = process.env.REACT_APP_COMMON_URL + "my-account/viewcoupon";

  const uid = parseInt(userId());

  const navigate = useNavigate();

  const ManageCouponsAPIHandler = async (searchVal, sortval, colName) => {
    if (colName) {
      localStorage.setItem("colName", colName);
    }
    if (sortval) {
      localStorage.setItem("sortval", sortval);
    }
    // if (searchval) {
    //   localStorage.setItem("search", searchval);
    // }
    const ColName = localStorage.getItem("colName");
    const SortVal = parseInt(localStorage.getItem("sortval"));
    const val = {
      business_id: uid,
      limit: 5,
      offset: searchVal ? 0 : pageNumber,
      search_value: searchVal,
      column_name: ColName ? ColName : colName,
      sort_type: SortVal ? SortVal : sortval,
    };

    if (!val.sort_type && !val.column_name) {
      setLoading(true);
    }
    const CouponTableData = await LatestCouponsApi(val, () => {
      navigate("/");
    });
    if (CouponTableData === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else if (CouponTableData.status === 429) {
      toast.error(CouponTableData.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (CouponTableData.success === true) {
        if (!val.sort_type && !val.column_name) {
          setLoading(false);
        }
        setManageCoupons(CouponTableData.data);
        setTotalPageCount(CouponTableData.total_row);
        setLimit(CouponTableData.limit);
      } else {
        setManageCoupons([]);
        setTotalPageCount(0);
        setLimit(5);
        setLoading(false);
      }
    }
  };

  const handleDelete = async (flag) => {
    if (flag == true) {
      const val = {
        business_id: uid,
        coupon_id: deleteId,
      };

      setLoading(true);
      const filteredList = await DeleteCouponApi(val, () => {
        navigate("/");
      });
      ManageCouponsAPIHandler();
      setLoading(false);
      setModalShow(false);

      if (filteredList.success === true) {
        toast.success(filteredList.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else if (filteredList.status === 429) {
        setLoading(true);
        toast.error(filteredList.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error(filteredList.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }
  };

  const HandleSort = (columnValue) => {
    // coupon_name
    if (columnValue == "coupon_name") {
      if (flag.coupon_name === 0) {
        ManageCouponsAPIHandler(search, 1, "coupon_name");
        setFlag((ps) => {
          return { ...ps, coupon_name: 1 };
        });
      } else if (flag.coupon_name === 1) {
        ManageCouponsAPIHandler(search, 2, "coupon_name");
        setFlag((ps) => {
          return { ...ps, coupon_name: 2 };
        });
      } else {
        ManageCouponsAPIHandler(search, 0, "coupon_name");
        setFlag((ps) => {
          return { ...ps, coupon_name: 0 };
        });
      }
    }

    // mms_city_name
    if (columnValue == "mms_city_name") {
      if (flag.mms_city_name === 0) {
        ManageCouponsAPIHandler(search, 1, "mms_city_name");
        setFlag((ps) => {
          return { ...ps, mms_city_name: 1 };
        });
      } else if (flag.mms_city_name === 1) {
        ManageCouponsAPIHandler(search, 2, "mms_city_name");
        setFlag((ps) => {
          return { ...ps, mms_city_name: 2 };
        });
      } else {
        ManageCouponsAPIHandler(search, 0, "mms_city_name");
        setFlag((ps) => {
          return { ...ps, mms_city_name: 0 };
        });
      }
    }
    // coupon_code
    if (columnValue == "coupon_code") {
      if (flag.coupon_code === 0) {
        ManageCouponsAPIHandler(search, 1, "coupon_code");
        setFlag((ps) => {
          return { ...ps, coupon_code: 1 };
        });
      } else if (flag.coupon_code === 1) {
        ManageCouponsAPIHandler(search, 2, "coupon_code");
        setFlag((ps) => {
          return { ...ps, coupon_code: 2 };
        });
      } else {
        ManageCouponsAPIHandler(search, 0, "coupon_code");
        setFlag((ps) => {
          return { ...ps, coupon_code: 0 };
        });
      }
    }

    // download_count
    if (columnValue == "download_count") {
      if (flag.download_count === 0) {
        ManageCouponsAPIHandler(search, 1, "download_count");
        setFlag((ps) => {
          return { ...ps, download_count: 1 };
        });
      } else if (flag.download_count === 1) {
        ManageCouponsAPIHandler(search, 2, "download_count");
        setFlag((ps) => {
          return { ...ps, download_count: 2 };
        });
      } else {
        ManageCouponsAPIHandler(search, 0, "download_count");
        setFlag((ps) => {
          return { ...ps, download_count: 0 };
        });
      }
    }

    // redeemed_count
    if (columnValue == "redeemed_count") {
      if (flag.redeemed_count === 0) {
        ManageCouponsAPIHandler(search, 1, "redeemed_count");
        setFlag((ps) => {
          return { ...ps, redeemed_count: 1 };
        });
      } else if (flag.redeemed_count === 1) {
        ManageCouponsAPIHandler(search, 2, "redeemed_count");
        setFlag((ps) => {
          return { ...ps, redeemed_count: 2 };
        });
      } else {
        ManageCouponsAPIHandler(search, 0, "redeemed_count");
        setFlag((ps) => {
          return { ...ps, redeemed_count: 0 };
        });
      }
    }
  };

  const handleChange = (e) => {
    let val = e.target.value;
    setSearch(val.trim());
    if (!val) {
      ManageCouponsAPIHandler("");
    }
  };

  const handleSearchClick = () => {
    ManageCouponsAPIHandler(search);
  };
  // enter-keyboard
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      ManageCouponsAPIHandler(search);
    }
  };
  const win = window.location.href;

  useEffect(() => {
    RemoveSortkeys();
  }, [win]);

  useEffect(() => {
    ManageCouponsAPIHandler();
    // window.scrollTo(0, 0);
  }, [pageNumber]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="manage-vou-main pt-3 pb-3">
        <p className="page-maintitle pt-2">Latest Coupons</p>
        <div className="manage-vou">
          <InputGroup className="search-bar">
            <InputGroup.Text>
              <MdSearch />
              <Form.Control
                type="text"
                placeholder="Search"
                maxLength={20}
                onChange={handleChange}
                onKeyPress={handleKeypress}
              />
            </InputGroup.Text>
            <Form.Control />
            <Button variant="outline-secondary" onClick={handleSearchClick}>
              Search
            </Button>
          </InputGroup>
        </div>
      </div>
      <SearchBarResults SearchValue={search} />
      <div className="table-responsive-xl black-header">
        <table className="recentact-table mt-3 table ver-middle manage-vou-table man-cou-dash-table">
          <thead>
            <tr>
              {/* <th className="radio-colors"></th> */}

              <th>
                <Button
                  onClick={() => HandleSort("coupon_name")}
                  style={{ marginLeft: "0" }}
                >
                  Coupon Name{" "}
                  {flag.coupon_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.coupon_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              {/* <th width="150px">
                Marketplace<Image loading="lazy" src={sortpic} className="sortimg"></Image>
              </th> */}
              <th>
                <Button
                  onClick={() => HandleSort("mms_city_name")}
                  style={{ margin: "auto" }}
                >
                  Marketplace{" "}
                  {flag.mms_city_name === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.mms_city_name === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={() => HandleSort("coupon_code")}
                  style={{ margin: "auto" }}
                >
                  Coupon Code{" "}
                  {flag.coupon_code === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.coupon_code === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={() => HandleSort("download_count")}
                  style={{ margin: "auto" }}
                >
                  Downloaded Coupons{" "}
                  {flag.download_count === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.download_count === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th>
                <Button
                  onClick={() => HandleSort("redeemed_count")}
                  style={{ margin: "auto" }}
                >
                  Redeemed Coupons{" "}
                  {flag.redeemed_count === 0 ? (
                    <FaSort></FaSort>
                  ) : flag.redeemed_count === 1 ? (
                    <FaSortUp></FaSortUp>
                  ) : (
                    <FaSortDown></FaSortDown>
                  )}
                </Button>
              </th>
              <th style={{ textAlign: "center" }}>Status</th>
              {/* <th className="action-main">Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {manageCouponsData && manageCouponsData.length > 0 ? (
              manageCouponsData.map((item, key) => {
                return (
                  <tr>
                    <td
                      className="text-left text-limit-2 blue-underline-text"
                      title={item.coupon_name}
                      style={{ display: "flex", justifyContent: "initial" }}
                    >
                      <Link to={`/my-account/view-coupon/${item.coupon_id}`}>
                        {item.coupon_name}
                      </Link>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.mms_city_name}
                    </td>
                    <td style={{ textAlign: "center" }}>{item.coupon_code}</td>
                    <td style={{ textAlign: "center" }}>
                      {item.coupon_download}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {item.coupon_redeemed}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <div className={`status_bg_${item.status_name}`}>
                        {item.status_name}
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} className="text-center">
                  <p className="no-record">No records available!</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div>
        {totalPageCount > 5 ? (
          <Pagination
            TotalPageCount={totalPageCount}
            Limit={limit}
            SetPageNumber={setPageNumber}
          />
        ) : (
          <></>
        )}
      </div>
      <MyVerticallyCenteredModal
        handleDeletefuc={handleDelete}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default ManageCouponsCouponDashboard;
